const CACHE_CONFIRMATION_FORM_DATA = 'CACHE_CONFIRMATION_FORM_DATA';
const CLEAR_CACHED_CONFIRMATION_FORM_DATA =
  'CLEAR_CACHED_CONFIRMATION_FORM_DATA';

export default {
  CACHE_CONFIRMATION_FORM_DATA,
  CLEAR_CACHED_CONFIRMATION_FORM_DATA,
};
